export default __webpack_public_path__ + "static/media/facebook5.c1f3eff6.svg";